import React from 'react';
import { useIntl } from 'react-intl';
import IframeContent from '~/modules/common/components/IframeContent';
import { useMeContext } from '~/modules/me';
import { usePageTitle } from '~/modules/common/title';
import { useHideFooter } from '~/modules/common/hooks';
import { ScheduleManagementIcon } from '~/modules/common/components/Icons';

const ScheduleManagementPage = () => {
  const intl = useIntl();
  const { uiRootPath } = useMeContext();

  usePageTitle([{ messageId: 'routes.scheduleManagement' }]);
  useHideFooter();

  return (
    <IframeContent
      src={`${uiRootPath}embedded/schedulemanagement`}
      title={intl.formatMessage({ id: 'routes.scheduleManagement' })}
    />
  );
};

const scheduleManagementRoute = ({ me, intl }) => {
  const hasPermission = me.permissions.find(
    p =>
      p.permissionActionUri ===
        'urn:replicon:shift-assignment-action:view-shift-assignments' &&
      p.dataAccessLevelUris.includes(
        'urn:replicon:shift-assignment-data-access-level:schedule-manager'
      )
  );

  return {
    path: '/schedulemanagement',
    icon: ScheduleManagementIcon,
    isSideBarRoute: true,
    component: ScheduleManagementPage,
    hidden: !me.featureFlags.isPsaPrpEmbedSchedulesInPolarisEnabled,
    title: () => intl.formatMessage({ id: 'routes.scheduleManagement' }),
    showDivider: false,
    hasPermission: Boolean(hasPermission),
    exact: false
  };
};

export default scheduleManagementRoute;
